import styled from 'styled-components';
import BathTubSvg from '../../assets/amenities/bathtub.svg';

const BathTubIcon = styled(BathTubSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default BathTubIcon;
